import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import BlogService from "../../../services/API/BlogService";

import Pagination from "react-js-pagination";
import { Modal, Button } from "react-bootstrap";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MultiSelect } from 'primereact/multiselect';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { forceLinksToNewTab } from "../../../utils/utils";

export default function BlogLists() {
    const [page, setPage] = useState(1);
    const [myData, setMyData] = useState([]);
    const [id, setId] = useState(null);
    const [edit, setEdit] = useState(false);
    const [show, setShow] = useState(false);
    const [add, setAdd] = useState(false);
    const [title, setTitle] = useState(null);
    const [short_description, setShortDescription] = useState(null);
    const [description, setDescription] = useState(null);
    const [displaySearchField, setDisplaySearchField] = useState(false);
    const [searchkey, setSearchkey] = useState(null);
    const [file, setFile] = useState(null);
    const [fileTwo, setFileTwo] = useState(null);
    const [image, setImage] = useState(null);
    const [imageTwo, setImageTwo] = useState(null);
    const [status, setStatus] = useState(null);
    const [del, setDel] = useState(false);
    const [reason, setReason] = useState("");
    const [row_no, setNo] = useState("");
    const [categoryLists, setCategoryLists] = useState([]);
    const [category, setCategory] = useState([]);
    const [metaTitle, setMetaTitle] = useState(null);
    const [metaDescription, setMetaDescription] = useState(null);
    const [seoKeywords, setSeoKeywords] = useState(null);
    const [tags, setTags] = useState(null);

    const postsPerPage = 20;

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const queryKey = "api/blogs";
    const {
        data: blogList,
        isLoading: loading,
        isSuccess: success,
        isFetching,
        refetch,
    } = useQuery([queryKey], BlogService.getBlogsList, {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
    const indexOfLastPost = page * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const blogLists = Array.isArray(myData)
        ? myData?.slice(indexOfFirstPost, indexOfLastPost)
        : blogList?.data?.slice(indexOfFirstPost, indexOfLastPost);

    useEffect(() => {
        if (blogList?.data) {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            setMyData(blogList?.data);
        }
    }, [blogList]);

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, [page]);

    const handleAdd = () => {
        getCategory();
        setAdd(true);
        setTitle(null);
        setShortDescription(null);
        setDescription(null);
        setFile(null);
        setFileTwo(null);
        setMetaTitle(null);
        setMetaDescription(null);
        setSeoKeywords(null);
        setCategory(null);
        setTags(null);
    };

    const handleEdit = async (blog) => {
        try {
            const blogData = await BlogService.editBlog(
                blog?.id
            );
            setId(blog?.id);
            setEdit(blogData?.data);
            setImage(blogData?.blog_image_url);
            setImageTwo(blogData?.thumbnail_image_url);
            if (blogData?.data) {
                setShow(true);
            }
        } catch (er) {
            toast.error(er);
        }
    };

    useEffect(() => {
        if (edit) {
            getCategory();
            setTitle(edit?.blog_title);
            setShortDescription(edit?.blog_short_description);
            setDescription(edit?.blog_description);
            setFile(edit?.blog_image);
            setFileTwo(edit?.thumbnail_image);
            setImage(edit?.blog_image_url);
            setImageTwo(edit?.thumbnail_image_url);
            setMetaTitle(edit?.meta_title);
            setMetaDescription(edit?.meta_description);
            setSeoKeywords(edit?.seo_keywords);
            setCategory(getCategoryList(edit?.category_types));
            setTags(edit?.tags);
        }
    }, [edit]);

    const submitForm = () => {
        if (edit) {
            updateBlog();
        }
    };

    const submitAddForm = () => {
        addBlog();
    }

    const handleHide = () => {
        setAdd(false);
        setShow(false);
        setTitle(null);
        setShortDescription(null);
        setDescription(null);
        setFile(null);
        setFileTwo(null);
        setMetaTitle(null);
        setMetaDescription(null);
        setSeoKeywords(null);
    };

    const addBlog = async () => {
        const payload = {
            blog_title: title,
            blog_short_description: forceLinksToNewTab(short_description),
            blog_description: forceLinksToNewTab(description),
            blog_image: file,
            thumbnail_image: fileTwo,
            meta_title: metaTitle,
            meta_description: metaDescription,
            seo_keywords: seoKeywords,
            category: category,
            tags: tags
        };
        let staticContent = true
        const error = validateBlog(payload, staticContent);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await BlogService.addBlog(
                payload
            );
            if (response) {
                toast.success("Blog Content created successfully");
                handleHide();
                if (searchkey) {
                    handleSearch({ target: { value: searchkey } }, 1);
                } else {
                    refetch();
                }
                setImmediate(null);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const updateBlog = async () => {
        const payload = {
            blog_title: title,
            blog_short_description: forceLinksToNewTab(short_description),
            blog_description: forceLinksToNewTab(description),
            blog_image: file,
            thumbnail_image: fileTwo,
            meta_title: metaTitle,
            meta_description: metaDescription,
            seo_keywords: seoKeywords,
            category: category,
            tags: tags
        };
        let staticContent = true
        const error = validateBlog(payload, staticContent);
        if (error) {
            toast.error(error);
            return;
        }
        try {
            const response = await BlogService.updateBlog(
                edit?.id,
                payload
            );
            if (response) {
                toast.success("Blog Content updated successfully");
                handleHide();
                if (searchkey) {
                    handleSearch({ target: { value: searchkey } }, 1);
                } else {
                    refetch();
                }
                setImmediate(null);
            }
        } catch (e) {
            toast.error(e);
        }
    };

    const validateBlog = (data, staticContent = false) => {
        if (!data.category || data.category.length <= 0) return "Please choose category";
        if (!data.blog_title) return "Please enter blog title";
        if (data.blog_title.length < 1 || data.blog_title.length >= 500) {
            return "Please enter valid title with 1-500 characters";
        }
        if (staticContent) {
            if (!htmlToPlainText(data?.blog_short_description)?.trim()) {
                return "Please enter blog short description";
            }
            if (!htmlToPlainText(data?.blog_description)?.trim()) {
                return "Please enter blog description";
            }
        }
        if (!data.tags) return "Please enter tags";
        // if (!data.meta_title) return "Please enter meta title";
        // if (!data.meta_description) return "Please enter meta description";
        // if (!data.seo_keywords) return "Please enter seo keywords";
        if (!data.blog_image) return "Please upload blog image";
        if (data?.blog_image?.size > 2097152)
            return "Please ensure that the image size does not exceed 2MB";
        if (!data.thumbnail_image) return "Please upload blog thumbnail image";
        if (data?.thumbnail_image?.size > 2097152)
            return "Please ensure that the image size does not exceed 2MB";
    };

    function htmlToPlainText(html) {
        if (!html) return "";
        // Create a temporary DOM element
        var tempElement = document.createElement('div');
        // Set its innerHTML to the provided HTML content
        tempElement.innerHTML = html;
        // Use textContent to get the plain text
        return tempElement.textContent || tempElement.innerText || "";
    }

    const handleSearch = async (e, page) => {
        const value = e.target.value;
        setSearchkey(value);
        const payload = { blog_title: value };
        const { data } = await BlogService.searchBlog(payload);
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        if (!page) {
            setPage(1);
        }
        setMyData(data);
    };

    const clearFilter = () => {
        setDisplaySearchField(false);
        setSearchkey(null);
        setTitle(null);
        setShortDescription(null);
        setDescription(null);
        setFile(null);
        setFileTwo(null);
        setMetaTitle(null);
        setMetaDescription(null);
        setSeoKeywords(null);
        setMyData(blogList);
        setPage(1);
        setTags(null);
    };

    const handleDelete = async (blog) => {
        const status = blog.status === 1 ? 0 : 1;
        const menu = 'Blogs';
        try {
            await BlogService.deactivateBlog(blog?.id, {
                status, reason, menu, row_no
            });
            const message =
                blog?.status === 1
                    ? "Blog Deactivated Successfully"
                    : "Blog Activated Successfully";
            toast.success(message);
            setDel(null);
            refetch();
        } catch (er) {
            toast.error(er);
        }
    };

    const getCategory = async () => {
        try {
            const cateList = await BlogService.getAllBlogCategory();
            if (cateList?.data) {
                setCategoryLists(cateList?.data);
            }
        } catch (e) {
            toast.error(e);
        }
    }

    const getCategoryList = (data) => {
        const result = data?.map(value => ({
            name: value.category_name,
            id: value.id
        }));
        return result;
    };

    return (
        <div style={{ borderTop: "0px", paddingTop: "30px" }}>
            <div
                style={{
                    paddingTop: "30px",
                }}
                className="d-flex justify-content-end align-items-center gap-2 p-2"
            >
                {blogList?.length !== myData?.length && (
                    <button
                        type="button"
                        className="button_new pull-right"
                        onClick={clearFilter}
                    >
                        Clear Filters
                    </button>
                )}
                {displaySearchField ? (
                    <input
                        type="text"
                        className="button_new pull-right "
                        value={searchkey || ""}
                        onChange={handleSearch}
                        placeholder="Search"
                    />
                ) : (
                    <a
                        className=" button_new pull-right"
                        onClick={() => {
                            setDisplaySearchField(true);
                        }}
                        onKeyDown={() => {
                            setDisplaySearchField(true);
                        }}
                    >
                        <i
                            class="fa fa-search requests-icons"
                            aria-hidden="true"
                            title="Search"
                        ></i>
                    </a>
                )}
                <a
                    className=" button_new pull-right"
                    onClick={() => handleAdd()}
                    onKeyDown={() => handleAdd()}
                    title="Add Blog"
                >
                    <i className="fa fa-plus fa-fw requests-icons"></i>
                </a>
            </div>
            <div className="table-responsive ">
                <table className="table table-bordered table-hover dataTable no-footer" style={{ tableLayout: "fixed" }}>
                    <thead>
                        <tr role="row" style={{ fontWeight: 700 }}>
                            <th className="text-center" width="34px">
                                S. No.
                            </th>
                            <th className="text-center">Blog Title</th>
                            <th className="text-center" width="50px">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {blogLists?.length !== 0 ? (
                            blogLists?.map((blog, index) => {
                                return (
                                    <tr key={blog?.id}>
                                        <td className="text-start align-middle">
                                            {postsPerPage * (page - 1) + index + 1}
                                        </td>
                                        <td className="text-start align-middle">
                                            {blog?.blog_title}
                                        </td>


                                        <td className="text-start align-middle">
                                            <a
                                                title="Add"
                                                onClick={() => handleEdit(blog)}
                                                onKeyDown={() => handleEdit(blog)}
                                            >
                                                <i className="fa fa-edit fa-fw cursor-pointer"></i>
                                            </a>
                                            {blog?.status === 1 ? (
                                                <i
                                                    className="fa fa-circle fa-fw txt-success pe-auto"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    title="Deactivate"
                                                    onClick={() => { setDel(blog); setReason(""); setNo(postsPerPage * (page - 1) + index + 1) }}
                                                    onKeyDown={() => setDel(blog)}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa fa-circle fa-fw txt-fail"
                                                    title="Activate"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => { setDel(blog); setReason(""); setNo(postsPerPage * (page - 1) + index + 1) }}
                                                    onKeyDown={() => setDel(blog)}
                                                ></i>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={3} className="p-2 text-center">
                                    {loading || isFetching
                                        ? "Loading..."
                                        : "No data found"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {myData.length > postsPerPage && (
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={postsPerPage}
                        totalItemsCount={myData.length}
                        pageRangeDisplayed={postsPerPage}
                        onChange={handlePageChange}
                    />
                )}
            </div>
            {show && (
                <Modal
                    show={show}
                    animation={false}
                    onHide={handleHide}
                    dialogClassName="modal-lg"
                    enforceFocus={false}
                >
                    <Modal.Header closeButton>
                        <h3 className="modal-title">Edit Blog</h3>
                    </Modal.Header>
                    <Modal.Body
                        style={{ height: "80vh", overflowY: "scroll" }}
                    >
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Category{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <MultiSelect
                                value={category}
                                onChange={(e) => setCategory(e.value)}
                                options={getCategoryList(categoryLists)}
                                optionLabel="name"
                                placeholder="Select Category"
                                className="w-full md:w-20rem w-100"
                                display="chip"
                                filter
                                appendTo="self"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Title{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Blog Name"
                                value={title || ""}
                                // disabled={true}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Short Description{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            {short_description ? (
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={short_description == null ? '<p></p>' : short_description}
                                    onChange={(event, editor) => {
                                        const rawHtml = editor.getData();
                                        setShortDescription(rawHtml || '<p></p>');
                                    }}
                                />
                            ) : ""
                            }
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Description{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            {description ? (
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={description == null ? '<p></p>' : description}
                                    onChange={(event, editor) => {
                                        const rawHtml = editor.getData();
                                        setDescription(rawHtml || '<p></p>');
                                    }}
                                />
                            ) : ""
                            }
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Tags{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <textarea className="form-control mb-3" placeholder="Enter Tags" value={tags || ""} onChange={(e) => setTags(e.target.value)}></textarea>
                            <div className="note">
                                <strong>Note:</strong> Separate tags by comma
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Meta Title{" "}
                                {/* <span style={{ color: "red" }}> *</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Meta Title"
                                value={metaTitle || ""}
                                onChange={(e) => setMetaTitle(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Meta Description{" "}
                                {/* <span style={{ color: "red" }}> *</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Meta Description"
                                value={metaDescription || ""}
                                onChange={(e) => setMetaDescription(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                SEO Keywords{" "}
                                {/* <span style={{ color: "red" }}> *</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter SEO Keywords"
                                value={seoKeywords || ""}
                                onChange={(e) => setSeoKeywords(e.target.value)}
                            />
                        </div>
                        <div className="form-group padding-top-10">
                            <label htmlFor="tags">
                                {" "}Blog Image{" "}
                                <span style={{ color: "red" }}> *</span>
                                (Dimensions: 736 px width  × 385 px height)
                            </label>
                            <div className="d-flex">
                                <input
                                    type="file"
                                    className={
                                        typeof file === "string" ? `form-control file1` : `form-control`
                                    }
                                    style={{ flexBasis: typeof file === "string" ? "10%" : "" }}
                                    placeholder="Name"
                                    onChange={(e) => setFile(e.target.files[0])}
                                />
                                {typeof file === "string" && (
                                    <input
                                        type="text"
                                        className="form-control file2"
                                        style={{ flexBasis: "90%" }}
                                        // disabled
                                        value={typeof file === "string" ? image : ""}
                                    />
                                )}
                            </div>

                            <div className="note">
                                <strong>Note:</strong> Accepted format : JPG,PNG,JPEG,SVG,WEBP,AVIF Max size :2MB
                            </div>
                        </div>
                        <div className="form-group padding-top-10">
                            <label htmlFor="tags">
                                {" "}Blog Thumbnail Image {" "}
                                <span style={{ color: "red" }}> *</span>
                                (Dimensions: 261 px width × 137 px height)
                            </label>
                            <div className="d-flex">
                                <input
                                    type="file"
                                    className={
                                        typeof fileTwo === "string" ? `form-control file1` : `form-control`
                                    }
                                    style={{ flexBasis: typeof fileTwo === "string" ? "10%" : "" }}
                                    placeholder="Name"
                                    onChange={(e) => setFileTwo(e.target.files[0])}
                                />
                                {typeof fileTwo === "string" && (
                                    <input
                                        type="text"
                                        className="form-control file2"
                                        style={{ flexBasis: "90%" }}
                                        // disabled
                                        value={typeof fileTwo === "string" ? imageTwo : ""}
                                    />
                                )}
                            </div>

                            <div className="note">
                                <strong>Note:</strong> Accepted format : JPG,PNG,JPEG,SVG,WEBP,AVIF Max size :2MB
                            </div>
                            {/* {imageTwo ? (
                                <div className="form-group">
                                    <img src={imageTwo} alt="" width="250px;" />
                                </div>
                            ) : ""
                            } */}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn button_new_success"
                            onClick={submitForm}
                        >
                            Save
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
            {add && (
                <Modal
                    show={add}
                    animation={false}
                    onHide={handleHide}
                    dialogClassName="modal-lg"
                    enforceFocus={false}
                >
                    <Modal.Header closeButton>
                        <h3 className="modal-title">Add Blog</h3>
                    </Modal.Header>
                    <Modal.Body
                        style={{ height: "80vh", overflowY: "scroll" }}
                    >
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Category{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <MultiSelect
                                value={category}
                                onChange={(e) => setCategory(e.value)}
                                options={getCategoryList(categoryLists)}
                                optionLabel="name"
                                placeholder="Select Category"
                                className="w-full md:w-20rem w-100"
                                display="chip"
                                filter
                                appendTo="self"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Title{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Blog Name"
                                value={title || ""}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Short Description{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={short_description == null ? '<p></p>' : short_description}
                                onChange={(event, editor) => {
                                    const rawHtml = editor.getData();
                                    setShortDescription(rawHtml || '<p></p>');
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Blog Description{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={description == null ? '<p></p>' : description}
                                onChange={(event, editor) => {
                                    const rawHtml = editor.getData();
                                    setDescription(rawHtml || '<p></p>');
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Tags{" "}
                                <span style={{ color: "red" }}> *</span>
                            </label>
                            <textarea className="form-control mb-3" placeholder="Enter Tags" value={tags || ""} onChange={(e) => setTags(e.target.value)}></textarea>
                            <div className="note">
                                <strong>Note:</strong> Separate tags by comma
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Meta Title{" "}
                                {/* <span style={{ color: "red" }}> *</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Meta Title"
                                value={metaTitle || ""}
                                onChange={(e) => setMetaTitle(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                Meta Description{" "}
                                {/* <span style={{ color: "red" }}> *</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter Meta Description"
                                value={metaDescription || ""}
                                onChange={(e) => setMetaDescription(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}
                                SEO Keywords{" "}
                                {/* <span style={{ color: "red" }}> *</span> */}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-3"
                                placeholder="Enter SEO Keywords"
                                value={seoKeywords || ""}
                                onChange={(e) => setSeoKeywords(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}Blog Image{" "}
                                <span style={{ color: "red" }}> *</span>
                                (Dimensions: 736 px width  × 385 px height)
                            </label>
                            <div className="d-flex">
                                <input
                                    type="file"
                                    className="form-control"
                                    placeholder="Name"
                                    onChange={(e) => setFile(e.target.files[0])}
                                />
                            </div>

                            <div className="note">
                                <strong>Note:</strong> Accepted format : JPG,PNG,JPEG,SVG,WEBP,AVIF Max size :2MB
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="tags">
                                {" "}Blog Thumbnail Image {" "}
                                <span style={{ color: "red" }}> *</span>
                                (Dimensions: 261 px width × 137 px height)
                            </label>
                            <div className="d-flex">
                                <input
                                    type="file"
                                    className="form-control"
                                    placeholder="Name"
                                    onChange={(e) => setFileTwo(e.target.files[0])}
                                />
                            </div>

                            <div className="note">
                                <strong>Note:</strong> Accepted format : JPG,PNG,JPEG,SVG,WEBP,AVIF Max size :2MB
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            className="btn button_new_success"
                            onClick={submitAddForm}
                        >
                            Save
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
            <Modal
                show={!!del}
                onHide={() => setDel(null)}
                animation={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Are you Sure?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Do you want to {del?.status === 1 ? "deactivate " : "activate "}
                        this document?
                    </p>

                    {/* 13-Aug-2024 Karthikeyan p1 status log start */}
                    <div>
                        <p><label for="w3review">Reason <span style={{ color: "red" }}> *</span></label></p>
                        <textarea
                            id="w3review"
                            placeholder="Reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            style={{ width: "100%" }}
                            maxLength={500}
                        />
                    </div>
                    {/* 13-Aug-2024 Karthikeyan p1 status log end */}
                    <div className="d-flex gap-3 justify-content-end">
                        <Button
                            variant="danger"
                            className="px-3 py-2"
                            onClick={() => setDel(null)}
                        >
                            No
                        </Button>
                        <Button
                            variant="success"
                            className="px-3 py-2"
                            onClick={() => handleDelete(del)}
                            disabled={!reason}
                        >
                            Yes
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}
